<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e67NaN">
</p><p class="crth" id="d7e222">The $7.50 Bunny That Changed the World <br/>© 2012 Gretta Parker. All rights reserved.</p>
<p class="crt" id="d7e322">No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.</p>
<p class="crt" id="d7e442">Published in the United States by BQB Publishing <br/>(Boutique of Quality Books Publishing Company)<br/><a href="http://www.bqbpublishing.com" id="d14e64" target="_blank">www.bqbpublishing.com</a></p>
<p class="crt" id="d14e66">Printed in the United States of America </p>
<p class="crt" id="d14e68">978-1-937084-64-6 (h) <br/>978-1-937084-71-4 (p) <br/>978-1-937084-72-1 (e) </p>
<p class="crt" id="d14e74">Library of Congress Control Number: 2012944844 </p>
<p class="crt" id="d14e76">Book design by Robin Krauss, <a href="http://www.lindendesign.biz" id="d14e78" target="_blank">www.lindendesign.biz</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Park_9781937084721_epub_c2_r1.vue?75db3e8c